import { GET_WHATSAPP_SUMMARY_SUCCESS, GET_WHATSAPP_SUMMARY_REQUEST, GET_WHATSAPP_SUMMARY_FAILURE, } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getWhatsappSummaryReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_WHATSAPP_SUMMARY_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case GET_WHATSAPP_SUMMARY_REQUEST:
            return Object.assign({}, state);
        case GET_WHATSAPP_SUMMARY_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default getWhatsappSummaryReducer;
